export const tgc_list = [
    '0',
    '3',
    '6',
    '11',
    '22'
]